/** getAllCookies */
export const getAllCookies = (): any => {
	const cookieStr = document.cookie;
	const cookieArr = cookieStr.split(';');
	const cookieMap: any = [];

	cookieArr.forEach((item) => {
		const keyValue = item.split('=');
		const key = (keyValue[0] || '').trim();
		const value = (keyValue[1] || '').trim();

		cookieMap[key] = value;
	});

	return cookieMap;
};

/** getCookie */
export const getCookie = (key: any): any => {
	const cookies = getAllCookies();

	return key ? cookies[key] : cookies;
};

/** setCookie */
// export const setCookie = (key: any, value: any): any => {
// 	document.cookie = `${key}=${value};path=/`;
// };

/** setCookie */
export const setCookie = (key: any, value: any, domain?: any): any => {
	let cookie = `${key}=${encodeURIComponent(value)}`;

	if (domain) {
		console.log('domain: ', domain);
		cookie += `;domain=${domain}`;
	}

	document.cookie = `${cookie};path=/`;
	console.log('`${cookie};path=/`: ', `${cookie};path=/`);
};
